export const upkeyPlatformPlay2Icon = {
    data: `<svg viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 9.21863C19.3333 9.98843 19.3333 11.9129 18 12.6827L3 21.343C1.66667 22.1128 8.49539e-07 21.1505 9.16837e-07 19.6109L1.67394e-06 2.29043C1.74124e-06 0.750828 1.66667 -0.211422 3 0.558378L18 9.21863Z" fill="currentColor"/></svg>`,
    name: 'play-2'
};